import r from '../Utils/fetch';
import { green, red, orange, blue } from '@mui/material/colors';

const w: any = window;
// api-connectors-v2: every admin route below was ported from v1 (QV2-4910).
const endPoint = `${w.API_CONNECTORS_CONFIG_URL}`;

export const CONNECTOR_PROCESS_PENDING = 0,
	CONNECTOR_PROCESS_START = 50,
	CONNECTOR_PROCESS_STOP_FORCE = 100,
	CONNECTOR_PROCESS_STOP_WITH_NO_ERROR = 200,
	CONNECTOR_PROCESS_STOP_WITH_ERROR = 300;

export interface IStatus {
	id: number;
	name: string;
	color?: string;
}
export const connectorAccountProcessStatus: IStatus[] = [
	{ id: CONNECTOR_PROCESS_PENDING, name: 'Pending progress', color: blue[300] },
	{ id: CONNECTOR_PROCESS_START, name: 'In progress', color: blue[500] },
	{
		id: CONNECTOR_PROCESS_STOP_FORCE,
		name: 'Stop forced',
		color: orange[500],
	},
	{
		id: CONNECTOR_PROCESS_STOP_WITH_NO_ERROR,
		name: 'Success',
		color: green[500],
	},
	{
		id: CONNECTOR_PROCESS_STOP_WITH_ERROR,
		name: 'Stop with error',
		color: red[500],
	},
];

export const CONNECTOR_PROCESS_RESOLUTION_WAIT = 0,
	CONNECTOR_PROCESS_RESOLUTION_IN_PROGRESS = 100,
	CONNECTOR_PROCESS_RESOLUTION_BY_CUSTOMER = 200,
	CONNECTOR_PROCESS_RESOLUTION_OK = 300,
	CONNECTOR_PROCESS_RESOLUTION_OK_BY_CUSTOMER = 400,
	CONNECTOR_PROCESS_RESOLUTION_OK_BY_ANTOTHER_PROCESS = 500;

export const resolutionStatusLst: IStatus[] = [
	{
		id: CONNECTOR_PROCESS_RESOLUTION_WAIT,
		name: 'En attente de résolution',
		color: red[500],
	},
	{
		id: CONNECTOR_PROCESS_RESOLUTION_IN_PROGRESS,
		name: 'Résolution en cours',
		color: orange[500],
	},
	{
		id: CONNECTOR_PROCESS_RESOLUTION_BY_CUSTOMER,
		name: 'A fixer par le client',
		color: green[500],
	},
	{ id: CONNECTOR_PROCESS_RESOLUTION_OK, name: 'Résolu' },
	{
		id: CONNECTOR_PROCESS_RESOLUTION_OK_BY_CUSTOMER,
		name: 'Résolu par le client',
		color: green[500],
	},
	{
		id: CONNECTOR_PROCESS_RESOLUTION_OK_BY_ANTOTHER_PROCESS,
		name: 'Résolu par un autre process',
		color: green[500],
	},
];

export interface IConnectorAccountProcess {
	id: string;
	projectFolderId: string;
	skuParent: string;
	sku: string;
	accountId: string;
	ServiceName: string;
	ProcessStartDate: string;
	ProcessEndDate: string;
	NbrOfActiveRows: number;
	NbrOfInsertedRows: number;
	Status: number;
	resolutionStatus: number;
	resolutionMessage?: string;
	resolutionThemes?: string;
	ErrorDetails?: string;
	ErrorResolution?: string;
	nbrRequestsWithWarning?: number | null;
}

export interface IConnectorAccountProcessStats {
	totalCount: number;
	countInProgress: number;
	countSuccess: number;
	countWithError: number;
	countInsertedRows: number;
	countActiveRows: number;
	totalCost: number;
}

export const loadStats = (
	queryString: string
): Promise<IConnectorAccountProcessStats> =>
	r({
		url: `${endPoint}/v1/admin/logs/stats?${queryString}`,
		method: 'GET',
	});

export const reload = (processId: string): any =>
	r({
		url: `${endPoint}/v1/admin/logs/${processId}/refresh`,
		method: 'GET',
	});

export const forceStop = (processId: string): any =>
	r({
		url: `${endPoint}/v1/admin/logs/${processId}/stop`,
		method: 'GET',
	});

export const sendResolution = (processId: string, data: any): any =>
	r({
		url: `${endPoint}/v1/admin/logs/${processId}/resolution`,
		method: 'PATCH',
		data,
	});

export interface IForceBatchItem {
	projectFolderId: string;
	sku: string;
	accountId: string;
}

export interface IForceBatchResult {
	projectFolderId: string;
	sku: string;
	accountId: string;
	success: boolean;
	error?: string;
}

export interface IForceBatchOptions {
	connectorAccounts: IForceBatchItem[];
	cleanupOldProcessData?: boolean;
	// Test mode fields (E2E testing)
	testMode?: boolean;
	connectorVersion?: string;
	processorVersion?: string;
}

export const forceBatch = (
	options: IForceBatchOptions
): Promise<IForceBatchResult[]> =>
	r({
		url: `${endPoint}/v1/admin/cron/force-batch`,
		method: 'POST',
		data: options,
	});

export interface IHistoryBatchOptions {
	connectorAccounts: IForceBatchItem[];
	startDate: string;
	endDate: string;
	cleanupOldProcessData?: boolean;
	// Test mode fields (E2E testing)
	testMode?: boolean;
	connectorVersion?: string;
	processorVersion?: string;
}

export const historyBatch = (
	options: IHistoryBatchOptions
): Promise<IForceBatchResult[]> =>
	r({
		url: `${endPoint}/v1/admin/history/batch`,
		method: 'POST',
		data: options,
	});
